angular.module('ccs').directive('searcher', searcher)

function searcher() {
  return {
    restrict: 'E',
    templateUrl: 'app/views/common/searcher.html',
    scope: {
      search: '=',
      searchExecuted: '=?',
    },
    link: function (scope, element) {
      const ENTER = 13

      function search() {
        scope.$parent.searchExecuted = true
        scope.$parent.pageNumber = 1
        scope.$parent.changePage()
      }

      function clearSearch() {
        scope.$parent.search = undefined
      }

      element.on('paste', '#searcher-input', function (e) {
        e.preventDefault()
        const pasted = (
          e.originalEvent?.clipboardData || window.clipboardData
        ).getData('text')

        const trimmed = pasted.trim()
        const input = e.target
        const start = input.selectionStart
        const end = input.selectionEnd
        const value = input.value

        const newValue =
          value.substring(0, start) + trimmed + value.substring(end)

        input.value = newValue

        scope.$parent.search = newValue
        scope.$applyAsync()

        const caretPos = start + trimmed.length
        input.setSelectionRange(caretPos, caretPos)
      })

      element.on('keyup', '#searcher-input', function (event) {
        if (event.keyCode === ENTER) {
          search()
        }
      })

      scope.handleSearchClick = () => {
        search()
      }

      scope.clearSearch = () => {
        clearSearch()
        search()
        scope.$parent.searchExecuted = false
      }
    },
  }
}
